import { type User } from '@scoring/types';
import { useApiMutation } from '../../queries/useApiMutation';
import { produce } from 'immer';
import { queryKeys } from '../../queries/queryKeys';
import { setQueryDataSafe } from '../../utils/queryUtilities';
import { del } from '../../queries';

export const useDeleteUserImageMutation = () => {
    const mutation = useApiMutation<{ userId: string }>({
        mutationFn: async ({ userId }) => del(`users/${userId}/profile-picture`, undefined),
        onManualCacheUpdate: (queryClient, _response, args) => {
            setQueryDataSafe<User[]>(queryClient, queryKeys.users.list(), (previous) =>
                produce(previous, (draft) => {
                    const index = draft.findIndex((ath) => ath.id === args.userId);
                    if (index !== -1) draft[index].profilePictureImageId = null;
                })
            );
        },
    });

    return mutation;
};
